import './copy_and_duplicate_button_set.less';

import React from 'react';
import classNames from 'classnames';
import ButtonSet from 'zoomforth_component_lib/btn_set_basic.jsx';
import Button from 'zoomforth_codesbane_editor/component_lib/button.jsx';

const CopyAndDuplicateButtonSet = ({ copyText, onDuplicateClick, onCopyClick, section })=> (
  <div className={classNames('copy-and-duplicate-button-set', { 'inside-tab': section?._isInsideTab })}>
    <ButtonSet>
      <Button dark onClick={onDuplicateClick}>
        Duplicate
      </Button>

      { section?._isInsideTab ? null : (
        <Button dark onClick={onCopyClick}>
          { copyText }
        </Button>
      )}
    </ButtonSet>
  </div>
);

CopyAndDuplicateButtonSet.defaultProps = {
  copyText: 'Copy'
};

export default CopyAndDuplicateButtonSet;